import $ from 'jquery';
import * as THREE from 'three';
import {$win} from '../common';


export default function Field(canvasSelector) {
    'use strict';

    let _this = this;
    let options = new function() {
        this.size = 4000; // particles spread in the plane
        this.sizeH = 3000; // particles spread in height
        this.speed = 2;
        this.clearColor = 0x222222;
        this.particlesCount = 3000;
        this.particlesSize = 9.0;
        this.particlesColor = 0xf1f5f9; // кажется цвет устанавливается в функции отрисовки круга generateTexture()
    };
    let camera, scene, renderer;
    let $container;
    let positions, alphas;


    function alphaFromPosition(ny) {
        let opacity;
        if (ny < 0.2 || ny > 0.8) {
            opacity = Math.abs(Math.abs(ny - 0.5) - 0.5) * 5;
        } else {
            opacity = 1;
        }
        return opacity;
    }
    function generateTexture() {
        let canvas = document.createElement('canvas');
        canvas.width = 2048;
        canvas.height = 2048;
        let ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f1f5f9';
        ctx.beginPath();
        ctx.arc(1024,1024,1024,0,2*Math.PI);
        ctx.fill();

        let texture = new THREE.Texture(canvas);
        texture.needsUpdate = true;
        return texture;
    }

    this.fillParticleData = function(newOpts) {
        if (newOpts) {
            options = newOpts;
        }

        let size2 = options.size / 2;
        let sizeH2 = options.sizeH / 2;
        for (let i = 0; i < positions.length; i += 3) {
            // positions
            let angle = 2 * Math.PI * Math.random();
            let u = Math.random() + Math.random();
            let radius = u > 1 ? 2 - u : u;
            positions[i] = radius * Math.cos(angle) * size2;
            positions[i + 1] = radius * Math.sin(angle) * size2;
            positions[i + 2] = Math.random() * options.sizeH - sizeH2;
            // alphas
            let nz = positions[i + 2] / options.sizeH + 0.5;
            alphas[i / 3] = alphaFromPosition(nz);
        }
    };

    function initField() {
        positions = new Float32Array(options.particlesCount * 3);
        alphas = new Float32Array(options.particlesCount);

        _this.fillParticleData();

        let geometry = new THREE.BufferGeometry();
        geometry.addAttribute('position', new THREE.BufferAttribute(positions, 3).setDynamic(true));
        geometry.addAttribute('alpha', new THREE.BufferAttribute(alphas, 1).setDynamic(true));
        geometry.computeBoundingSphere();
        //

        // uniforms
        let uniforms = {
            size: {value: options.particlesSize},
            color: {value: new THREE.Color(options.particlesColor)},
            texture: {value: generateTexture()}
        };
        // point cloud material
        let material = new THREE.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: document.getElementById('vertexshader').textContent,
            fragmentShader: document.getElementById('fragmentshader').textContent,
            //blending: THREE.SubtractiveBlending,
            depthTest: false,
            depthWrite: false,
            //alphaTest: 0.5,
            transparent: true,
        });

        _this.particleCloud = new THREE.Points(geometry, material);
        scene.add(_this.particleCloud);
    }

    this.animateStream = function () {
        let time = Date.now();

        let size2 = options.size / 2;
        let sizeH2 = options.sizeH / 2;
        for (let i = 0; i < positions.length; i += 3) {

            //if (i === 0) { console.log(positions[i], positions[i + 1], positions[i + 2], radiusScale) }

            // update position
            positions[i + 2] += options.speed;
            // alpha
            let nz = positions[i + 2] / options.sizeH + 0.5;
            alphas[i / 3] = alphaFromPosition(nz);

            // recalc positions
            if (positions[i + 2] > sizeH2) {
                let angle = 2 * Math.PI * Math.random();
                let u = Math.random() + Math.random();
                let radius = u > 1 ? 2 - u : u;
                positions[i] = radius * Math.cos(angle) * size2;
                positions[i + 1] = radius * Math.sin(angle) * size2;
                positions[i + 2] = -sizeH2;

            }

        }
        _this.particleCloud.geometry.attributes.position.needsUpdate = true;
        _this.particleCloud.geometry.attributes.alpha.needsUpdate = true;

        //_this.particleCloud.rotation.y =  time * 0.00007;
    };



    initBase();
    initField();

    function initBase() {
        $container = $(canvasSelector);
        //
        camera = new THREE.PerspectiveCamera(60, $container.outerWidth() / $container.outerHeight(), 5, 15000);
        camera.position.z = 1500;
        scene = new THREE.Scene();
        scene.fog = new THREE.Fog(options.clearColor, 1000, 10000);
        //
        renderer = new THREE.WebGLRenderer({antialias: true, logarithmicDepthBuffer: true});
        renderer.setClearColor(options.clearColor);
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize($container.outerWidth(), $container.outerHeight());
        $container[0].appendChild(renderer.domElement);
        //
        $win.on('resize fullpage_resized', function () {
            camera.aspect = $container.outerWidth() / $container.outerHeight();
            camera.updateProjectionMatrix();
            renderer.setSize($container.outerWidth(), $container.outerHeight());
        });
    }

    let animating = 0;
    this.play = function () {
        // cant start if already playing
        if (animating) {
            return;
        }
        animating = true;
        animate();
    };
    this.stop = function () {
        window.cancelAnimationFrame(animating);
        animating = null;
    };
    function animate() {
        if (!animating) {
            return;
        }
        _this.animateStream();
        renderer.render(scene, camera);
        animating = window.requestAnimationFrame(animate);
    }
}



// WEBPACK FOOTER //
// ./scripts/three-field.js